/**
 * Configuración de AWS Amplify
 *
 * IMPORTANTE: Después de deployar el servicio auth, actualizar estos valores
 * con los outputs de CloudFormation:
 * - UserPoolId
 * - UserPoolClientId
 * - Region
 */

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_zztd1R3kI',
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '2fegr7sj16kuqcrn8hcsq1vk5o',
      region: 'us-east-1',
      signUpVerificationMethod: 'code',
      loginWith: {
        email: true,
      },
      userAttributes: {
        email: {
          required: true,
        },
        name: {
          required: true,
        },
      },
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
};

export default awsConfig;
